import axios from 'axios';

const resolveBaseUrl = () => {
  if (process.env.REACT_APP_BASE_URL) {
    return process.env.REACT_APP_BASE_URL;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.hostname}:8000/api/v1`;
  }
  return 'http://localhost:8000/api/v1';
};

const BASE_URL = resolveBaseUrl();

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // send httpOnly nar_access_token cookie (AF-03)
});

api.interceptors.request.use((config) => {
  const devToken = sessionStorage.getItem('devAccessToken');
  if (devToken) {
    config.headers.Authorization = `Bearer ${devToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('accessToken');
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('devAccessToken');
    }
    return Promise.reject(error);
  }
);

export default api;
